import axiosInstance from "../mainService";
const technologyService = {
    getTechnology(search, page, limit, company) {
        const sanitizedSearch = search && search.trim() !== '' ? search : 'all';
        return axiosInstance.get('/data/m146_technologies/name/' + sanitizedSearch + '/' + page + '/' + limit + '/' + company).then(response => {
            return {
                data: response.data,
                headers: response.headers, // Total data dari header
            };
        });
    },
    addTechnology(technology) {
        return axiosInstance.post('/insert-data/m146_technologies', technology);
    },
    updateTechnology(technology) {
        return axiosInstance.put(`/update-data/m146_technologies/${technology.id}`, technology);
    },
    deleteTechnology(technologyId) {
        return axiosInstance.delete(`/delete-data/m146_technologies/${technologyId}`);
    },
    totalAllTechnology(company) {
        const sanitizedSearch = 'all';
        return axiosInstance.get(`/count-data/m146_technologies/name/${sanitizedSearch}/${company}`);
    }
}

export default technologyService;